<div class="flex flex-col bg-slate-100 rounded shadow grow">
    <table class="table-auto">
        <thead>
            <tr class="bg-ponder-light text-slate-50 font-bold text-left">
                <th class="p-2 pr-6 rounded-tl">Id</th>
                <th class="p-2 pr-6">Started By</th>
                <th class="p-2 pr-6">Started On</th>
                <th class="p-2 pr-6">Duration</th>
                <th class="p-2"></th>
                <th class="p-2 pr-6 rounded-tr">Status</th>
            </tr>
        </thead>
        <tbody>
            @if (!isLoading && loadingSuccess) {
                @if (taskRuns && taskRuns.length) {
                    @for (taskRun of taskRuns ; track taskRun.id) {
                        <tr (click)="onTaskRunClicked(taskRun)" class="text-xs hover:cursor-pointer hover:bg-ponder-linkhover hover:bg-opacity-10" [ngClass]="{ 'bg-white' : $even, 'bg-slate-50' : $odd }">
                            <td class="p-2 pr-6">{{ taskRun.id }}</td>
                            <td class="p-2 pr-6"></td>
                            <td class="p-2 pr-6" title="{{ taskRun.start }}">{{ taskRun.start | date }}</td>
                            <td class="p-2 pr-6">{{ taskRun.duration }}</td>
                            <td class="pl-2"><div class="w-2 h-2 shadow-sm rounded-sm" [style.background]="getStatusColor(taskRun)"></div></td>
                            <td class="p-2 pr-6">{{ taskRun.status }}</td>
                        </tr>
                    }
                }
            }
        </tbody>
    </table>
    @if (isLoading) {
        <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
    } @else if (!taskRuns || !taskRuns.length) {
        <div class="p-8 text-center">
            This task has not been run.
        </div>
    }
    <!-- Paging -->
    <div class="flex flex-row p-2 pt-1 pb-1 text-xs sm:text-sm bg-slate-100 gap-2 items-center rounded-b border-t">
        <div class="grow">
            {{ (totalRuns ? pageStart + 1 : 0) }} - {{ pageEnd }} of {{ totalRuns }}
        </div>
        <button (click)="onPrevClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="(pageStart <= 1)">
            &lt; Prev
        </button>
        <button (click)="onNextClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="(pageEnd >= totalRuns)">
            Next &gt;
        </button>
    </div>
    <div class="min-h-1 min-w-1"></div>
</div>